import { ReactNode } from "react";

import { Card } from "@magnetic/card";

import { CliCommandResponse, CommandAction } from "src/gen/schema/bilge/api";

import "./mockShellHelpTextOutput.scss";

interface MockShellHelpTextOutputProps {
  readonly cmdResult?: CliCommandResponse;
  readonly cmdAction?: CommandAction;
}

export const MockShellHelpTextOutput = ({
  cmdResult,
  cmdAction
}: MockShellHelpTextOutputProps) => {
  if (!cmdResult) {
    return null;
  }

  if (
    cmdAction === CommandAction.COMPLETE &&
    (cmdResult.commandCompletions?.length ?? 0) <= 1
  ) {
    return null;
  }

  const helpResult: ReactNode[] =
    cmdResult.commandCompletions?.map((cmd) => {
      return (
        <div key={`${cmd.keyword}`} className="mock-shell-output-help">
          <div className="mock-shell-output-help-key">{cmd.keyword}</div>
          <div className="mock-shell-output-help-value">{cmd.helpString}</div>
        </div>
      );
    }) ?? [];

  if (cmdResult.validCommand) {
    helpResult.unshift(
      <div key="enter" className="mock-shell-output-help">
        <div className="mock-shell-output-help-key">{"<enter>"}</div>
        {cmdAction !== CommandAction.EXPAND && (
          <div className="mock-shell-output-help-text">
            {"Press enter to execute the command"}
          </div>
        )}
      </div>
    );
  }

  if (helpResult.length === 0) {
    return null;
  }

  return <Card className="mock-shell-output-help-container">{helpResult}</Card>;
};
